import styled, { css } from 'styled-components'

export interface StepperButtonStyledProps {
  $size?: 'small' | 'medium' | 'large'
  $direction?: 'up' | 'down'
}

const sizeStyles = {
  small: css`
    width: 20px;
    height: 20px;
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
  `,
  medium: css`
    width: 24px;
    height: 24px;
    font-size: ${({ theme }) => theme.typography.fontSize.small};
  `,
  large: css`
    width: 28px;
    height: 28px;
    font-size: ${({ theme }) => theme.typography.fontSize.body};
  `,
}

export const Button = styled.button<StepperButtonStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: 1;
  user-select: none;
  flex-shrink: 0;

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.secondary};
    border-color: ${({ theme }) => theme.colors.border.focus};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.border.focus};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.tertiary};
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.tertiary};
    border-color: ${({ theme }) => theme.colors.border.light};
  }
`
